import { styled } from '@mui/material/styles';
import { Box, IconButton } from '@mui/material';

export const ActionButtonsContainer = styled(Box)({
  display: 'flex',
  gap: 4,
  alignItems: 'center'
});

export const ActionButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.5)
}));
